import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { UserRole } from '../models/user.interface';
import { selectUserRole, selectUser } from '../store/auth/auth.selectors';

/**
 * RoleService - Gestisce i ruoli utente
 * 
 * Usa i dati dallo store (caricati da user/me) per ottenere il ruolo dell'utente.
 */
@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private store = inject(Store);

  /**
   * Ottiene il ruolo dell'utente corrente dallo store
   */
  getUserRole(): Observable<UserRole | undefined> {
    return this.store.select(selectUserRole);
  }

  /**
   * Verifica se l'utente ha un ruolo specifico
   */
  hasRole(role: UserRole): Observable<boolean> {
    return this.getUserRole().pipe(
      map(userRole => userRole === role)
    );
  }

  /**
   * Verifica se l'utente ha uno dei ruoli specificati
   */
  hasAnyRole(roles: UserRole[]): Observable<boolean> {
    return this.getUserRole().pipe(
      map(userRole => userRole !== undefined && roles.includes(userRole))
    );
  }

  /**
   * Verifica se l'utente è admin
   */
  isAdmin(): Observable<boolean> {
    return this.hasRole(UserRole.ADMIN);
  }

  /**
   * Verifica se l'utente è admin o moderatore
   */
  isAdminOrModerator(): Observable<boolean> {
    return this.hasAnyRole([UserRole.ADMIN, UserRole.MODERATOR]);
  }

  /**
   * Verifica se l'utente è un utente normale
   */
  isUser(): Observable<boolean> {
    return this.hasRole(UserRole.USER);
  }

  /**
   * Ottiene i dati utente completi dallo store
   */
  getUserData() {
    return this.store.select(selectUser);
  }
}


